<template>

  <base-edit :title="`Abonnement auf ${subscription.title} ändern`"
             name="settings-payment-subscription-update"
             v-bind="$attrs"
             v-on="$listeners">
    <SettingsPaymentSubscriptionForm type="update" :subscription="subscription"/>
  </base-edit>

</template>

<script>
import BaseEdit from '@/components/base/form/BaseEdit'
import SettingsPaymentSubscriptionForm from './SettingsPaymentSubscriptionForm.vue'

export default {
  name: 'SettingsPaymentSubscriptionUpdate',
  components: { BaseEdit, SettingsPaymentSubscriptionForm },
  props: {
    subscription: Object
  }
}
</script>
